import { useState } from 'react';
import { FiCreditCard, FiExternalLink } from 'react-icons/fi';
import { PaymentChargeModal } from '../../components/ui/PaymentChargeModal/PaymentChargeModal';
import { useAuth } from '../../contexts';
import styles from './SuspendedScreen.module.css';

const SUPPORT_URL =
    'https://api.whatsapp.com/send/?phone=558587069521&text=Oi%2C+preciso+do+suporte+com+o+sistema+financeiro+diario%21&type=phone_number&app_absent=0';

export function SuspendedScreen() {
    const { logout } = useAuth();
    const [chargeOpen, setChargeOpen] = useState(false);

    const handleSupport = () => {
        window.open(SUPPORT_URL, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className={styles.overlay}>
            <div className={styles.card}>
                <div className={styles.icon}>🔒</div>
                <h1 className={styles.title}>Acesso suspenso</h1>
                <p className={styles.body}>
                    Identificamos uma pendência no pagamento da sua assinatura.
                    Regularize o pagamento abaixo para reativar seu acesso automaticamente.
                </p>
                <button className={styles.payBtn} onClick={() => setChargeOpen(true)}>
                    <FiCreditCard size={16} />
                    Pagar mensalidade
                </button>
                <button className={styles.supportBtn} onClick={handleSupport}>
                    <FiExternalLink size={16} />
                    Falar com o Suporte LTQ
                </button>
                <button className={styles.logoutBtn} onClick={logout}>
                    Sair da conta
                </button>
            </div>

            <PaymentChargeModal isOpen={chargeOpen} onClose={() => setChargeOpen(false)} />
        </div>
    );
}
